import reset_password_page from "./pages/reset_password.js";
import editor_page from "./pages/editor.js";
import forgotten_password_page from "./pages/forgotten_password.js";
import login_page from "./pages/login.js";
import projects_page from "./pages/projects.js";
import change_password_page from "./pages/change_password.js";
import attachment_page from "./pages/attachment.js";

editor_page();
projects_page();
login_page();
forgotten_password_page();
reset_password_page();
change_password_page();
attachment_page();
